import React from 'react';

import { StyledAvatarEmpty } from './Style';


type Props = {
  char1: string;
  char2?: string;
  highlighted?: boolean;
}

const AvatarEmpty = ({
  char1, char2, highlighted = false
}: Props) => {
  return <StyledAvatarEmpty className={highlighted ? 'highlighted' : ''}>
    <span>{char1.toUpperCase()} {char2?.toUpperCase()}</span>
  </StyledAvatarEmpty>
};

export default AvatarEmpty;
